/* eslint-disable no-inline-styles/no-inline-styles */
import { Divider, ShimmerBox } from '@/core/features';

export default function SpotResultsDesktopV4LoadingTile({
    hasTopLivePrices,
    isHorizontalOrientation,
}: {
    hasTopLivePrices: boolean;
    isHorizontalOrientation: boolean;
}) {
    if (isHorizontalOrientation) {
        return <SpotResultsDesktopV4LoadingTileHorizontal />;
    }

    return (
        <div className={'flex gap-5 h-full'}>
            <div
                className={'flex w-full h-full overflow-hidden border border-alto rounded-5'}
                style={{ minWidth: 538 }}
            >
                <div style={{ minWidth: 230 }}>
                    <ShimmerBox borderRadius={'0px'} />
                </div>
                <div className={'flex flex-col gap-10 w-full p-15'}>
                    <div className={'flex justify-between items-center'}>
                        <div className={'flex flex-col gap-10'}>
                            <ShimmerBox
                                borderRadius={'5px'}
                                height={'20px'}
                                width={'140px'}
                            />
                            <ShimmerBox
                                borderRadius={'5px'}
                                height={'13px'}
                                width={'110px'}
                            />
                        </div>
                        <div className={'flex gap-10'}>
                            <div className={'flex justify-center items-center'}>
                                <ShimmerBox
                                    borderRadius={'5px'}
                                    height={'13px'}
                                    width={'90px'}
                                />
                            </div>

                            <ShimmerBox
                                borderRadius={'5px'}
                                height={'40px'}
                                width={'40px'}
                            />
                        </div>
                    </div>
                    <div className={'flex gap-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'20px'}
                            width={'120px'}
                        />
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'20px'}
                            width={'80px'}
                        />
                    </div>
                    <div className={'mt-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'12px'}
                            width={'80px'}
                        />
                    </div>
                    <div className={'flex justify-start items-start gap-5'}>
                        {Array.from({ length: 12 }).map((_, index) => (
                            <ShimmerBox
                                height={'20px'}
                                key={index}
                                width={'20px'}
                            />
                        ))}
                    </div>
                    <div className={'flex flex-col gap-10 h-full mt-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'18px'}
                            width={'140px'}
                        />
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'18px'}
                            width={'80px'}
                        />
                    </div>
                    <div className={'flex justify-end items-end'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'40px'}
                            width={'200px'}
                        />
                    </div>
                </div>
            </div>
            {hasTopLivePrices && (
                <div
                    className={'flex flex-col justify-between gap-10 p-15 border border-alto rounded-5'}
                    style={{ minWidth: 122 }}
                >
                    <div className={'flex flex-col justify-center items-center gap-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                            width={'30px'}
                        />
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                        />
                    </div>
                    <Divider color={'alto'} />
                    <div className={'flex flex-col justify-center items-center gap-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                            width={'30px'}
                        />
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                        />
                    </div>
                    <Divider color={'alto'} />
                    <div className={'flex flex-col justify-center items-center gap-10'}>
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                            width={'30px'}
                        />
                        <ShimmerBox
                            borderRadius={'5px'}
                            height={'25px'}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

const SpotResultsDesktopV4LoadingTileHorizontal = () => {
    return (
        <>
            <div className={'flex flex-col gap-10 w-full'}>
                <div className={'flex justify-between items-center w-full'}>
                    <div className={'flex flex-col gap-5'}>
                        <ShimmerBox
                            height={'25px'}
                            width={'150px'}
                        />
                        <ShimmerBox
                            height={'25px'}
                            width={'150px'}
                        />
                    </div>
                    <ShimmerBox
                        height={'25px'}
                        width={'150px'}
                    />
                </div>
                <div className={'horizontalGrid grid gap-x-10 mt-10'}>
                    {Array.from({ length: 3 }).map((_, index) => (
                        <div
                            className={'w-full'}
                            key={`tile-${index}`}
                        >
                            <div className={'mb-10 rounded-5'}>
                                <ShimmerBox height={'230px'} />
                            </div>
                            <div className={'flex justify-between w-full mb-20 align-top'}>
                                <div className={'flex flex-col gap-5'}>
                                    <ShimmerBox
                                        height={'20px'}
                                        width={'94px'}
                                    />
                                </div>
                                <ShimmerBox
                                    height={'32px'}
                                    width={'32px'}
                                />
                            </div>
                            <ShimmerBox height={'29px'} />
                        </div>
                    ))}
                </div>
                <style jsx>{`
                    .horizontalGrid {
                        row-gap: 20px;
                        grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                    }
                `}</style>
            </div>
            <Divider
                color={'gallery'}
                marginBottom={20}
                marginTop={20}
            />
        </>
    );
};
